const preloadReloadKey = 'conthand_preload_reload_version';
const appVersion = import.meta.env.VITE_APP_VERSION;
const preloadReloadCooldownMs = 60_000;
export const preloadReloadPendingMs = 10_000;

let reloadRequestedAt: number | undefined;

export const isPreloadReloadPending = () =>
  reloadRequestedAt !== undefined &&
  window.performance.now() - reloadRequestedAt < preloadReloadPendingMs;

const consumePreloadReloadMark = () => {
  try {
    const isMarked = window.sessionStorage.getItem(preloadReloadKey) === appVersion;
    window.sessionStorage.removeItem(preloadReloadKey);
    return isMarked;
  } catch {
    return true;
  }
};

export const registerPreloadErrorReload = () => {
  const bootedAt = Date.now();
  const isReloadedBoot = consumePreloadReloadMark();

  window.addEventListener('vite:preloadError', (event) => {
    if (isPreloadReloadPending() || !window.navigator.onLine) {
      return;
    }

    const elapsedMs = Date.now() - bootedAt;

    if (isReloadedBoot && elapsedMs >= 0 && elapsedMs < preloadReloadCooldownMs) {
      return;
    }

    try {
      if (!appVersion) {
        return;
      }

      window.sessionStorage.setItem(preloadReloadKey, appVersion);
    } catch {
      return;
    }

    reloadRequestedAt = window.performance.now();
    event.preventDefault();
    window.location.reload();
  });
};
